import { css } from '@emotion/css';
import c from 'classnames';
import merge from 'lodash/merge';

import { PopoverContentProps } from './types';
import { getOriginValues } from './utils';

const DEFAULT_CLASSES = {
  background: 'bg-bg-primary',
  border: 'border border-solid border-divider',
  rounded: 'rounded-8',
  shadow: 'shadow-01',
};

const maxWidthStyles = (value: number) => css`
  max-width: ${value}rem;
`;

const minWidthStyles = (value: number) => css`
  min-width: ${value}rem;
`;

type Params = Pick<
  PopoverContentProps,
  'classes' | 'className' | 'maxWidth' | 'minWidth' | 'position'
>;

export const getPopoverParams = (params: Params) => {
  const { classes: classesProp, className, maxWidth, minWidth, position } = params;
  const { anchorOrigin, spacing, transformOrigin } = getOriginValues(position);
  const classes = merge({ ...DEFAULT_CLASSES, spacing }, classesProp?.Popover);

  return {
    anchorOrigin,
    popoverClasses: {
      paper: c(
        className,
        classes.spacing,
        classes.background,
        classes.border,
        classes.rounded,
        classes.shadow,
        classes.paper,
        maxWidth && maxWidthStyles(maxWidth),
        minWidth && minWidthStyles(minWidth),
      ),
      root: classes.root,
    },
    transformOrigin,
  };
};
